var Cortona3DSolo = require('solo');
var app = require('app').app;
var expand = require('lib/util').expand;

var base = require('./base'),
    getDocumentBaseURL = base.getDocumentBaseURL;

require('drawing.css');
var SVGDrawing = require('drawing');

var usedModules = require('app').usedModules;

var m_isSVGVisible = false;
var m_urlDrawing = '';

var m_lastX = 0, 
    m_lastY = 0;

var m_hotspotHighlightColor = '#FF0000';
var m_hotspotSelectionColor = '#FF0000';
var m_hotspotSelectionFillOpacity = 0.8;

var css = Cortona3DSolo.app.ui.css();

var CLASS_SELECTED = 'select',
    CLASS_HOVERED = 'hover';

// SVGDrawing hooks
expand(SVGDrawing, {
    delegate: {
        onProgress: function (loaded, total) {
            Cortona3DSolo.dispatch('app.onProgress', loaded, total);
        },
        didClickHotspot: function (name, keys, x, y) {
            m_lastX = x;
            m_lastY = y;
            Cortona3DSolo.dispatch('app.drawing.didSelectHotspot', name, keys);
        },
        didEnterHotspot: function (name, x, y) {
            m_lastX = x;
            m_lastY = y;
            SVGDrawing.toggleHotspotClass(name, 'hover', true);
            Cortona3DSolo.dispatch('app.drawing.didEnterHotspot', name);
            Cortona3DSolo.dispatch('app.drawing.didHoverHotspot', name, true);
        },
        didLeaveHotspot: function (name, x, y) {
            m_lastX = x;
            m_lastY = y;
            SVGDrawing.toggleHotspotClass(name, 'hover', false);
            Cortona3DSolo.dispatch('app.drawing.didLeaveHotspot', name);
            Cortona3DSolo.dispatch('app.drawing.didHoverHotspot', name, false);
        },
        didCallContextMenu: function (name, x, y, target) {
            m_lastX = x;
            m_lastY = y;
            Cortona3DSolo.dispatch('app.drawing.didCallContextMenu', name, x, y, target);
        },
        onZoomChange: function (zoom) {
            Cortona3DSolo.dispatch('app.drawing.didChangeScale', zoom);
        }
    }
});

/**
 * @private
 */
function attachSVGViewer(canvas) {
    if (!SVGDrawing.svg) {
        var svg = usedModules.drawing.config.element || usedModules.drawing.config.svg || (function () {
            var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            var beforeElement = canvas,
                parentElement;
            if (!canvas) {
                require('core.css');
                beforeElement = document.body.firstChild;
                parentElement = document.body;
            } else {
                parentElement = canvas.parentNode;
            }
            parentElement.insertBefore(svg, beforeElement);
            return svg;
        })();

        svg.parentNode.style.overflow = 'hidden';

        SVGDrawing.initialize(svg);
    }
}

function applyStyle() {
    css.render({
        '.cortona3dsolo-svg svg .recognized-aps[name]': {
            '& path.hover, & text.hover': {
                stroke: m_hotspotHighlightColor,
                strokeOpacity: 1
            },
            '& path.hover, & path.hover.select': {
                strokeWidth: '3',
            },
            '& path.select': {
                strokeWidth: '2',
            },
            '& text.hover, & text.hover.select': {
                strokeWidth: '.1em',
            },
            '& text.select': {
                strokeWidth: '.075em',
            },
            '& .recognized-aps-region.select': {
                fill: m_hotspotSelectionColor,
                fillOpacity: m_hotspotSelectionFillOpacity
            },
            '& .select': {
                stroke: m_hotspotSelectionColor,
                strokeOpacity: 1
            }
        }
    });
}

var appExports = {
    /**
     * The namespace represents an application interface to manage interactive 2D graphics.
     * 
     * Requires the use of the internal module `"drawing"`.
     * 
     * @namespace
     * @memberof module:solo.app
     * @example
Cortona3DSolo.use('drawing', {
    src: 'sample.svg'
});
Cortona3DSolo.app.initialize();
     */
    drawing: {
        /**
         * Loads the 2D illustration file.
         * Supported formats are SVG, JPG, PNG, GIF.
         * 
         * @async
         * @fires "app.drawing.didStartLoadDrawing"
         * @fires "app.drawing.didFinishLoadDrawing"
         * @fires "app.drawing.didFailLoadDrawing"
         * @param {string} imageURL
         * @param {boolean} [isRaster]
         * @returns {Promise} A promise 
         * @see external:Promise
         */
        load: function (imageURL, isRaster) {
            Cortona3DSolo.dispatch('app.drawing.didStartLoadDrawing', imageURL);
            if (typeof app.drawing.willStartLoadDrawing === 'function') {
                var shallBeURL = app.drawing.willStartLoadDrawing.call(app, imageURL);
                if (typeof shallBeURL == 'string') imageURL = shallBeURL;
            }
            imageURL = imageURL.replace(/\.(cgm|tiff?)$/i, '.svg');
            if (imageURL == m_urlDrawing) {
                Cortona3DSolo.dispatch('app.drawing.didFinishLoadDrawing', imageURL);
                return Promise.resolve();
            }
            if (!imageURL) {
                m_urlDrawing = '';
                SVGDrawing.unload();
                Cortona3DSolo.dispatch('app.drawing.didFinishLoadDrawing', m_urlDrawing);
                return Promise.resolve();
            }
            var url;
            if (app.util && app.util.createResourceURL) url = app.util.createResourceURL(imageURL);
            if (!url) {
                url = imageURL;
                if (!/^[^\/]+:/.test(url)) {
                    url = getDocumentBaseURL() + url;
                }
            }
            return new Promise(function (resolve, reject) {
                SVGDrawing.delegate.didCompleteLoad = function (url) {
                    if (app.util && app.util.revokeResourceURL) app.util.revokeResourceURL(url);
                    m_urlDrawing = imageURL;
                    Cortona3DSolo.dispatch('app.drawing.didFinishLoadDrawing', imageURL);
                    if (!usedModules.core) {
                        var arg = {
                            type: 'drawing',
                            baseURL: base.getBaseURL(imageURL)
                        };
                        Cortona3DSolo.dispatch('app.didFinishLoadDocument', arg);
                    }
                    resolve();
                };
                SVGDrawing.delegate.failedLoadingDocument = function (url, status) {
                    if (app.util && app.util.revokeResourceURL) app.util.revokeResourceURL(url);
                    m_urlDrawing = '';
                    SVGDrawing.unload();
                    Cortona3DSolo.dispatch('app.drawing.didFailLoadDrawing', imageURL, status);
                    if (!usedModules.core) {
                        Cortona3DSolo.dispatch('app.didFailLoadDocument', status);
                    }
                    reject(new Error('Image loading failed: status ' + status));
                };
                SVGDrawing.load(url, (isRaster !== void 0) ? isRaster : /\.(png|jpe?g|jpe|gif)$/i.test(imageURL));
            });
        },

        /**
         * Show or hides the 2D window.
         * 
         * @param {boolean} [visible=true]
         */
        show: function (visible) {
            visible = (typeof visible == 'undefined') ? true : !!visible;
            SVGDrawing[visible ? 'show' : 'hide']();
            m_isSVGVisible = !!visible;
        },

        /**
         * Checks if the 2D window visible
         * 
         * @returns {boolean}
         */
        isVisible: function () {
            return m_isSVGVisible;
        },

        /**
         * Selects the hotspot by its name.
         * 
         * @param {string} name
         * @param {HexColorString} [color] A string representing the color. Specify empty string to clear the selection. If omitted, the value specified in the options statement is used. See {@link module:solo.use use()} properties
         * @deprecated since version 2.1.0, use {@link module:solo.app.drawing.addSelectedObjects app.drawing.addSelectedObjects} instead
         */
        selectHotspot: function (name, color) {
            color = typeof color === 'undefined' ? m_hotspotSelectionColor : color;
            if (color === '') {
                SVGDrawing.removeObjectsWithClassName(name, CLASS_SELECTED);
            } else {
                SVGDrawing.addObjectsWithClassName(name, CLASS_SELECTED);
            }
        },

        /**
         * Highlights the hotspot by its name.
         * 
         * @param {string} name
         * @param {HexColorString} [color] A string representing the color. Specify empty string to clear the selection. If omitted, the value specified in the options statement is used. See {@link module:solo.use use()} properties
         * @deprecated since version 2.1.0, use {@link module:solo.app.drawing.addHoveredObjects app.drawing.addHoveredObjects} instead
         */
        highlightHotspot: function (name, color) {
            color = typeof color === 'undefined' ? m_hotspotHighlightColor : color;
            if (color === '') {
                SVGDrawing.removeObjectsWithClassName(name, CLASS_HOVERED);
            } else {
                SVGDrawing.addObjectsWithClassName(name, CLASS_HOVERED);
            }
        },

        /**
         * Highlights the hotspot by its name using the color specified in the options statement. See {@link module:solo.use use()} properties.
         * Unlike of the method {@link module:solo.app.drawing.highlightHotspot app.drawing.highlightHotspot()}, this method clears the last selection.
         * @deprecated since version 2.1.0, use {@link module:solo.app.drawing.setHoveredObjects app.drawing.setHoveredObjects} instead
         * @param {string} name
         */
        hoverHotspot: function (name) {
            SVGDrawing.setObjectsWithClassName(name, CLASS_HOVERED);
        },

        /**
         * Toggle the class value for all `SVGPathElement` and `SVGTextElement` inside a hotspot node; i.e., if the class exists then remove it and return `false`, if not, then add it and return `true`.
         * When the `force` argument is present: If the `force` argument evaluates to `true`, add the specified class value, and if it evaluates to `false`, remove it.
         * 
         * @method
         * @param {string} name
         * @param {string} className
         * @param {boolean} [force]
         * @returns {boolean}
         */
        toggleHotspotClass: SVGDrawing.toggleHotspotClass.bind(SVGDrawing),

        /**
         * Restores the default view.
         * @method
         * @since 1.4.3
         */
        reset: SVGDrawing.reset.bind(SVGDrawing),

        /**
         * Change the scale to the specified value.
         * @method
         * @param {number} value 
         * @since 1.4.3
         */
        scaleBy: SVGDrawing.scaleBy.bind(SVGDrawing),

        /**
         * Shifts the image along the X and Y axes by the number of pixels specified in the arguments.
         * @method
         * @param {number} valueX 
         * @param {number} valueY 
         * @since 1.7.0
         */
        shiftBy: SVGDrawing.shiftBy.bind(SVGDrawing),

        /**
         * Pans the image viewport to a named graphic object(s).
         * @method
         * @param {string|string[]} [names]
         * @since 2.1.0
         */
        centerTo: SVGDrawing.centerTo.bind(SVGDrawing),

        /**
         * Fits the image viewport to a named graphic object(s).
         * @method
         * @param {string|string[]} [names]
         * @param {number} [factor = 0.3]
         * @since 2.1.0
         */
        fitTo: SVGDrawing.fitTo.bind(SVGDrawing),

        /**
         * Checks if hotspot with specified name exists in the 2D illustration.
         * 
         * @param {string} name
         * @since 1.5.0
         */
        hotspotExists: function (name) {
            return Array.prototype.slice.call(SVGDrawing.svg.getElementsByTagName('a')).some(function (n) {
                return (n.getAttribute('name') === name);
            });
        },

        /**
         * Adds 2D objects to selected objects.
         * 
         * @param {string[]|string} names - Array of 2D object names or a single name
         * @since 2.1.0
         */
        addSelectedObjects: function (names) {
            SVGDrawing.addObjectsWithClassName(names, CLASS_SELECTED);
        },

        /**
         * Sets 2D objects to selected state.
         * 
         * @param {string[]|string} names - Array of 2D object names or a single name
         * @since 2.1.0
         */
        setSelectedObjects: function (names) {
            SVGDrawing.setObjectsWithClassName(names, CLASS_SELECTED);
        },

        /**
         * Removes 2D objects from selected objects.
         * 
         * @param {string[]|string} names - Array of 2D object names or a single name
         * @since 2.1.0
         */
        removeSelectedObjects: function (names) {
            SVGDrawing.removeObjectsWithClassName(names, CLASS_SELECTED);
        },

        /**
         * Returns an array of selected 2D objects.
         * 
         * @returns {string[]} An array of 3D object names
         * @since 2.1.0
         */
        getSelectedObjects: function () {
            return SVGDrawing.getObjectsWithClassName(CLASS_SELECTED);
        },

        /**
         * Adds 2D objects to hovered objects.
         * 
         * @param {string[]|string} names - Array of 2D object names or a single name
         * @since 2.1.0
         */
        addHoveredObjects: function (names) {
            SVGDrawing.addObjectsWithClassName(names, CLASS_HOVERED);
        },

        /**
         * Sets 2D objects to hovered state.
         * 
         * @param {string[]|string} names - Array of 2D object names or a single name
         * @since 2.1.0
         */
        setHoveredObjects: function (names) {
            SVGDrawing.setObjectsWithClassName(names, CLASS_HOVERED);
        },

        /**
         * Removes 2D objects from hovered objects.
         * 
         * @param {string[]|string} names - Array of 2D object names or a single name
         * @since 2.1.0
         */
        removeHoveredObjects: function (names) {
            SVGDrawing.removeObjectsWithClassName(names, CLASS_HOVERED);
        },

        /**
         * Returns an array of hovered 2D objects.
         * 
         * @returns {string[]} An array of 3D object names
         * @since 2.1.0
         */
        getHoveredObjects: function () {
            return SVGDrawing.getObjectsWithClassName(CLASS_HOVERED);
        },

        /**
         * @method
         * @param {string[]|string} names - Array of 2D object names or a single name
         * @param {string} className
         * @since 2.1.0
         */
         addObjectsWithClassName: SVGDrawing.addObjectsWithClassName.bind(SVGDrawing),

        /**
         * @method
         * @param {string[]|string} names - Array of 2D object names or a single name
         * @param {string} className
         * @since 2.1.0
         */
         setObjectsWithClassName: SVGDrawing.setObjectsWithClassName.bind(SVGDrawing),

        /**
         * @method
         * @param {string[]|string} names - Array of 2D object names or a single name
         * @param {string} className
         * @since 2.1.0
         */
         removeObjectsWithClassName: SVGDrawing.removeObjectsWithClassName.bind(SVGDrawing),

        /**
         * @method
         * @returns {string[]} An array of 3D object names
         * @param {string} className
         * @since 2.1.0
         */
         getObjectsWithClassName: SVGDrawing.getObjectsWithClassName.bind(SVGDrawing)
    }
};

/**
 * The HTML `<svg>` element.
 * 
 * @static
 * @member {SVGSVGElement} svg
 * @readonly
 * @memberof module:solo.app.drawing
 * @since 1.4.3
 */

/**
 * URL of the loaded image.
 * 
 * @static
 * @member {string} src
 * @readonly
 * @memberof module:solo.app.drawing
 * @since 2.4.3
 */

/**
 * The last X coordinate of the pointer point above the hotspot.
 * 
 * @static
 * @member {number} lastPointerX
 * @readonly
 * @memberof module:solo.app.drawing
 * @since 2.4.3
 */

/**
 * The last Y coordinate of the pointer point above the hotspot.
 * 
 * @static
 * @member {number} lastPointerY
 * @readonly
 * @memberof module:solo.app.drawing
 * @since 2.4.3
 */

/**
 * Gets or sets the color of the hovered hotspot in the 2D illustration.
 * 
 * @static
 * @member {HexColorString} hoverColor
 * @memberof module:solo.app.drawing
 * @since 1.5.0
 */

/**
 * Gets or sets the color of the selected hotspot in the 2D illustration.
 * 
 * @static
 * @member {HexColorString} selectionColor
 * @memberof module:solo.app.drawing
 * @since 1.5.0
 */

/**
 * Gets or sets the opacity level for filling the selected hotspot in the 2D illustration. A floating point number in range of 0 to 1.
 * 
 * @static
 * @member {number} selectionFillOpacity
 * @memberof module:solo.app.drawing
 * @since 2.3.1
 */

/**
 * Gets or sets the maximum scaling limit for the drawing.
 * 
 * @static
 * @member {number} maxScale
 * @memberof module:solo.app.drawing
 * @since 1.6.0
 */

/**
 * Gets or sets the minimum scaling limit for the drawing.
 * 
 * @static
 * @member {number} minScale
 * @memberof module:solo.app.drawing
 * @since 1.6.0
 */

Object.defineProperties(appExports.drawing, {
    'src': {
        get: function () {
            return m_urlDrawing;
        },
        enumerable: true
    },
    'lastPointerX': {
        get: function () {
            return m_lastX;
        },
        enumerable: true
    },
    'lastPointerY': {
        get: function () {
            return m_lastY;
        },
        enumerable: true
    },
    'svg': {
        get: function () {
            return SVGDrawing.svg;
        },
        enumerable: true
    },
    'hoverColor': {
        get: function () {
            return m_hotspotHighlightColor;
        },
        set: function (color) {
            m_hotspotHighlightColor = color;
            applyStyle();
        },
        enumerable: true
    },
    'selectionColor': {
        get: function () {
            return m_hotspotSelectionColor;
        },
        set: function (color) {
            m_hotspotSelectionColor = color;
            applyStyle();
        },
        enumerable: true
    },
    'selectionFillOpacity': {
        get: function () {
            return m_hotspotSelectionFillOpacity;
        },
        set: function (opacity) {
            var n = Number(opacity);
            if (!isNaN(n) && n >= 0 && n <= 1) {
                m_hotspotSelectionFillOpacity = n;
                applyStyle();
            }
        },
        enumerable: true
    },
    'maxScale': {
        get: function () {
            return SVGDrawing.maxScale;
        },
        set: function (value) {
            SVGDrawing.maxScale = value;
        },
        enumerable: true
    },
    'minScale': {
        get: function () {
            return SVGDrawing.minScale;
        },
        set: function (value) {
            SVGDrawing.minScale = value;
        },
        enumerable: true
    }
});

module.exports = {
    configure: function (options) {
        options = options || {};
        m_hotspotHighlightColor = options.hotspotHoverColor || options.hotspotHighlightColor || m_hotspotHighlightColor;
        m_hotspotSelectionColor = options.hotspotSelectionColor || m_hotspotSelectionColor;
        SVGDrawing.enableHoverFilling = (options.features || 0) & app.DRAWING_HOTSPOT_HIGHLIGHT_SOLID;
        SVGDrawing.enableDrawingOptimization = !((options.features || 0) & app.DISABLE_DRAWING_INTERACTIVITY_OPTIMIZATION);
        if (options.maxScale) SVGDrawing.maxScale = +options.maxScale;
        if (options.minScale) SVGDrawing.minScale = +options.minScale;
        applyStyle();
        return appExports;
    },

    attach: attachSVGViewer,

    getSVGViewer: function () {
        return SVGDrawing;
    }
};

/**
 * The hook method is invoked before loading the 2D illustration file. 
 * Must return the URL to the 2D illustration file that should be loaded.
 * 
 * @function willStartLoadDrawing  
 * @abstract 
 * @memberof module:solo.app.drawing
 * @param {string} imageURL Request URL to load 2D illustration
 * @returns {string} Returns URL to load 2D illustration
 */

/**
 * The hook method is invoked before loading the 2D illustration.
 * 
 * @function didStartLoadDrawing
 * @abstract 
 * @memberof module:solo.app.drawing
 * @param {string} url Request URL to load 2D illustration
 * @see The corresponding event {@link event:"app.drawing.didStartLoadDrawing" "app.drawing.didStartLoadDrawing"}
 */
/**
 * @event "app.drawing.didStartLoadDrawing"
 * @see The corresponding hook method {@link module:solo.app.drawing.didStartLoadDrawing app.drawing.didStartLoadDrawing()}
 */

/**
 * The hook method is invoked when the 2D illustration is failed to load.
 * 
 * @function didFailLoadDrawing
 * @abstract 
 * @memberof module:solo.app.drawing
 * @param {string} url Request URL to load 2D illustration
 * @param {string} status Status code
 * @see The corresponding event {@link event:"app.drawing.didFailLoadDrawing" "app.drawing.didFailLoadDrawing"}
 */
/**
 * @event "app.drawing.didFailLoadDrawing"
 * @see The corresponding hook method {@link module:solo.app.drawing.didFailLoadDrawing app.drawing.didFailLoadDrawing()}
 */

/**
 * The hook method is invoked when the 2D illustration is loaded.
 * 
 * @function didFinishLoadDrawing 
 * @abstract 
 * @memberof module:solo.app.drawing
 * @param {string} url URL of the loaded image
 * @see The corresponding event {@link event:"app.drawing.didFinishLoadDrawing" "app.drawing.didFinishLoadDrawing"}
 */
/**
 * @event "app.drawing.didFinishLoadDrawing"
 * @see The corresponding hook method {@link module:solo.app.drawing.didFinishLoadDrawing app.drawing.didFinishLoadDrawing()}
 */

/**
 * The hook is invoked when the hotspot is selected.
 * 
 * @function didSelectHotspot 
 * @abstract 
 * @memberof module:solo.app.drawing
 * @param {string} name Name of the selected hotspot
 * @param {number} keys 
 * @see The corresponding event {@link event:"app.drawing.didSelectHotspot" "app.drawing.didSelectHotspot"}
 */
/**
 * @event "app.drawing.didSelectHotspot"
 * @see The corresponding hook method {@link module:solo.app.drawing.didSelectHotspot app.drawing.didSelectHotspot()}
 */

/**
 * The hook is invoked when the hotspot is highlighted.
 * 
 * @function didHoverHotspot 
 * @abstract 
 * @memberof module:solo.app.drawing
 * @param {string} name Name of the selected hotspot
 * @param {boolean} hover -
 * - true - Hotspot is highlighted
 * - false - Hotspot is not highlighted
 * @see The corresponding event {@link event:"app.drawing.didHoverHotspot" "app.drawing.didHoverHotspot"}
 */
/**
 * @event "app.drawing.didHoverHotspot"
 * @see The corresponding hook method {@link module:solo.app.drawing.didHoverHotspot app.drawing.didHoverHotspot()}
 */

/**
 * The hook is invoked when the pointer is enter the hotspot.
 * 
 * @function didEnterHotspot
 * @abstract 
 * @memberof module:solo.app.drawing
 * @param {string} name Name of the hotspot
 * @see The corresponding event {@link event:"app.drawing.didEnterHotspot" "app.drawing.didEnterHotspot"}
 */
/**
 * @event "app.drawing.didEnterHotspot"
 * @see The corresponding hook method {@link module:solo.app.drawing.didEnterHotspot app.drawing.didEnterHotspot()}
 */

/**
 * The hook is invoked when the pointer is leave the hotspot.
 * 
 * @function didLeaveHotspot
 * @abstract 
 * @memberof module:solo.app.drawing
 * @param {string} name Name of the hotspot
 * @see The corresponding event {@link event:"app.drawing.didEnterHotspot" "app.drawing.didLeaveHotspot"}
 */
/**
 * @event "app.drawing.didLeaveHotspot"
 * @see The corresponding hook method {@link module:solo.app.drawing.didLeaveHotspot app.drawing.didLeaveHotspot()}
 */

/**
 * The hook method is invoked when the context menu is called in the 2D window. 
 * The mouse uses secondary button click. The touch device uses long tap.
 * 
 * @function didCallContextMenu 
 * @abstract 
 * @memberof module:solo.app.drawing
 * @param {string} name Name of the clicked hotspot or empty string
 * @param {number} offsetX The X coordinate relative to the target element 
 * @param {number} offsetY The Y coordinate relative to the target element
 * @param {HTMLElement} target Target element (parent of the element `<svg>`)
 * @see The corresponding event {@link event:"app.drawing.didCallContextMenu" "app.drawing.didCallContextMenu"}
 */
/**
 * @event "app.drawing.didCallContextMenu"
 * @see The corresponding hook method {@link module:solo.app.drawing.didCallContextMenu app.drawing.didCallContextMenu()}
 */

/**
 * The hook method is invoked when the scale of 2D illustration is changed.
 * 
 * @function didChangeScale 
 * @abstract 
 * @memberof module:solo.app.drawing
 * @param {number} zoom The value of the scale
 * @see The corresponding event {@link event:"app.drawing.didChangeScale" "app.drawing.didChangeScale"}
 */
/**
 * @event "app.drawing.didChangeScale"
 * @see The corresponding hook method {@link module:solo.app.drawing.didChangeScale app.drawing.didChangeScale()}
 */